/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable react/display-name */
import React from "react";
import { isEqual } from "lodash-es";

export interface BulkSelectableProps {
    checked?: boolean;
    onCheckedChange?: (val: boolean) => void;
    identifier?: any;
}

export interface BulkSelectableProps {
    selection?: any[];
    onSelectionChanged?: (selection: any[]) => void;
}

export interface State {}

export function bulkSelectable<T extends BulkSelectableProps>(
    Component: React.ComponentType<T>
) {
    type HOCProps = OwnProps;
    type OwnProps = BulkSelectableProps & T; //Props that are allowed to passed from Resulting component returned from HOC.

    return class extends React.PureComponent<HOCProps, State> {
        constructor(props: HOCProps) {
            super(props);
        }

        render() {
            const {
                selection = [],
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onSelectionChanged = () => {},
                identifier,
                onCheckedChange,
                ...rest
            } = this.props;
            let checked = rest.checked;

            const iCast: any[] = identifier;
            const tsBypass: T = rest as any;

            checked = false;
            if (isEqual(iCast.sort(), selection.sort()) && iCast.length > 0) {
                checked = true;
            }

            return (
                <Component
                    {...tsBypass}
                    checked={checked}
                    onCheckedChange={val => {
                        if (val) {
                            onSelectionChanged(iCast);
                        } else {
                            onSelectionChanged([]);
                        }
                    }}
                />
            );
        }
    };
}

export default bulkSelectable;
